module.exports = __webpack_public_path__ + "img/icon-tkm.61d6b54d.jpg";